import { render, staticRenderFns } from "./site-content.vue?vue&type=template&id=905766e2"
import script from "./site-content.vue?vue&type=script&lang=js"
export * from "./site-content.vue?vue&type=script&lang=js"
import style0 from "./site-content.vue?vue&type=style&index=0&id=905766e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports